import { SITE_LAYOUT } from 'config/siteLayout';
import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'VerifyEmailModal' })((theme) => ({
  modalRoot: {
    outline: 'none',
    '&:focus': { outline: 'none' },
  },
  modalBackdrop: {
    outline: 'none',
  },
  card: {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '40vw',
    padding: theme.spacing(3),
    maxWidth: SITE_LAYOUT.contentMaxWidth,
    maxHeight: '90vh',
    overflow: 'auto',
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    border: 'none',
    outline: 'none',
    boxShadow: 'none',
    '&:focus': {
      outline: 'none',
    },
    '&:focus-visible': {
      outline: 'none',
    },
    [theme.breakpoints.down('md')]: {
      width: '90%',
      maxWidth: '90vw',
      maxHeight: '90vh',
    },
  },
  closeButtonContainer: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
    zIndex: 1,
  },
  closeButton: {
    color: theme.palette.text.secondary,
    '&:hover': {
      color: theme.palette.text.primary,
    },
  },
  contentRoot: {
    padding: theme.spacing(0),
  },
}));
